(function($) {

//bgcolor: #eee
var brand_primary = '#116ca1';
var brand_secondary = '#3299BB';
var brand_info = '#3fb0ac';

$(document).ready(function() {

    // BS Tooltip
	$('[data-toggle="tooltip"]').tooltip();

    $().instagramFeed();
    
    $('.js-contact-form').contactFormInit();

    $('.js-social-share').shareButtonEvent();

    $('.gallery-icon').galleryLightbox();

    // JS smooth scroll
	$('.js-scroll').click(function(e){
        e.preventDefault();
	    var linkHref= $(this).attr('href');
	    $('html, body').animate(
	        {
	          scrollTop: $(linkHref).offset().top
	        }, 500
	    );
	});

    // Navbar inverse on scroll + shrink logo (not there at the moment)
	var $navbar = $('.js-navbar');
	var $header =  $('.js-header');

	// For pages without header image, already has .navbar--opaque
	if ($navbar.hasClass('navbar--noheader')) {
		$('.navbar-brand img').css({width: '85px'});
		$('img.logo-white').hide(); $('img.logo-black').show();
	}

	var header_height = $header.height() + 65;
	$(document).on('scroll ready', function(){
	    if($(this).scrollTop() > header_height)
	    {
			$navbar.removeClass('navbar--transparent').addClass("navbar--opaque");
			$('.navbar-brand img').css({width: '85px'});
			$('img.logo-white').hide(); $('img.logo-black').show();
		} else {
			$navbar.removeClass("navbar--opaque").addClass('navbar--transparent');
			$('.navbar-brand img').css({width: '115px'});
			$('img.logo-black').hide(); $('img.logo-white').show();
		}
	});
    
    $('li.search > form').submit(function(e){
        var search_string = $(this).find('input[name="s"]').val().replace(/ /g,'');
        if(search_string === '')
        {
            e.preventDefault();
            return false;
        }
        return true;
    });
    
    $('form.search-page .js-search').click(function(e){
        
        // Prevent default event
        e.preventDefault();
        
        // Fetch form
        var form = $(this).closest('form');
        
        // Fetch search field
        var searchfield = form.find('.js-searchfield');
        
        // Check if we got content
        if($searchfield.val() !== '')
        {  
            
            // Submit form
            form.submit();
        }
        else
        {
            // Trigger native form validation
            form.find('input[type="submit"]').click();
        }
        
    });
    
    var $searchfield = $('li.search .js-searchfield');
	$('li.search .js-search').click(function(e){
        
        // Prevent default event
        e.preventDefault();
        
        // Fetch form
        var form = $(this).closest('form');
        
        // Check if search is open
        if($searchfield.is(':visible'))
        {
            
            // Check if we got content
            if($searchfield.val() !== '')
            {
                // Submit form
                form.submit();
            }
            else
            {
                
                // Close form
        		$searchfield.css({display: 'none'});
            }
            
        }
        else
        {
            // Open form
    		$searchfield.css({display: 'inline-block'});
            $searchfield.focus();
        }
        
	});

});

$.fn.galleryLightbox = function () {

  $(this).magnificPopup({
    delegate:'a',
    type: 'image',
    image: {
      titleSrc: function(item) {
        return item.el.parent().parent().find('figcaption').html();

      }
    },
    gallery: {
      enabled: true
    }
  });
};

$.fn.contactFormInit = function() {
    var contactForm = $(this);
    if (!contactForm.length) return;
    contactForm.on('submit', function(e) {
        
        // Prevent default
        e.preventDefault();
        
        // Fetch submit button
        var btn = contactForm.find('button[type="submit"]');

        // Hide all messages
        contactForm.find('.something-error').hide();
        contactForm.find('.something-wrong').hide();
        contactForm.find('.something-success').hide();

        var dataConsent = document.getElementById('data_consent').checked;

        // Check that we got values
        if (! contactForm.find('#scheme_name').val() ||
            ! contactForm.find('#scheme_email').val() ||
            ! contactForm.find('#scheme_message').val() ||
            ! dataConsent
        ) {
            contactForm.find('.something-wrong').show();
            return;
        }
        
        // Set button to disabled during request
        btn.prop('disabled', true);
        btn.html(btn.data('text-loading'));

        // Do request
        $.ajax({
            url: contactForm.attr('action'),
            data: {
                action: 'contact_form',
                data: contactForm.serialize()
            },
            dataType: 'json',
            method: 'POST'
        }).done(function(res) {
            
            // Reset button
            btn.prop('disabled', false);
            btn.html(btn.data('text-default'));
            
            // Remove
            contactForm.find('.inquery-topics label').removeClass('active');
            
            if (res.statusCode === 200) {
                // Success
                contactForm.find('.something-success').show();
                contactForm[0].reset();
            }
            else
            {
                // Failure
                contactForm.find('.something-error').show();
            }
        });

    });

};

$.fn.shareButtonEvent = function() {
    $(this).on('click', function(e){
        e.preventDefault();
        var url         = $(this).attr('href');
        var window_name = $(this).data('window-name');
        var width       = $(this).data('window-width');
        var height      = $(this).data('window-height');
        window.open(url, window_name, "width=" + width + ", height=" + height);
    });
};

$.fn.instagramFeed = function ()
{

    // Fetch IG container
    var container        = $('#instagram-feed');

    // Check if container exists
    if(!container.length) return;

    // Fetch settings
    var token            = container.data('instagram-token');
    var number_of_images = container.data('number-of-image');

    // Do jsonp ajax request
    $.ajax({
        type:'GET',
        url: 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + token + '&count=' + number_of_images,
        dataType: 'jsonp',
        success: function(response) {

            // Loop through images
            $(response.data).each(function(i, el){

                // Get attributes
                var title = el.caption.text;
                var link  = el.link;
                var image = el.images.low_resolution.url;

                // Add image

                container.append('<li><a title="' + title + '" href="' + link + '" target="_blank"><img class="img-responsive" alt="' + title + '" src="' + image + '"></a></li>');

            });

        }
    });
};


})(jQuery);
    